import { axios } from '@/utils/request'

const api = {
  cooperation: '/cooperation/cooperation'
}

export default api
// 新闻类型
export function getCooperation(params) {
  return axios({
    url: api.cooperation,
    method: 'get',
    params
  })
}

export function deleteCooperation(params) {
  return axios({
    url: api.cooperation,
    method: 'delete',
    params
  })
}
